Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.loyalty-page'), wrapper;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    var $button = $('.js-loyalty-to-coupons', $wrapper),
        $refreshButton = $('.response-fancybox-wrapper .js-refresh');

    wrapper.loading = function (loading) {
        if (loading) {
            $button.attr("disabled", "disabled");
        } else {
            $button.removeAttr("disabled");
        }
    };

    wrapper.openFancyBox = function (response) {
        $.fancybox.open({
            src: '#response',
            type: 'inline',
            baseClass: response,
            afterClose: function () { location.reload(); }
        });
    }

    $refreshButton.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        //refresh page
        location.reload();
    });

    $button.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        wrapper.loading(true);

        var accountId = parseInt($(this).data('account-id'));      
        Vendd.MessageBus.publishAsync($wrapper, new Vendd.Account.Messages.ConvertPointsToCoupons(accountId));
    });
    
    wrapper.onSuccess = function (envelope) {
        wrapper.openFancyBox('response-success');
        wrapper.loading(false);
    };

    wrapper.onFailure = function (envelope) {       
        wrapper.openFancyBox('response-failure');
        wrapper.loading(false);
    };
    
    Vendd.MessageBus.subscribe(Vendd.Account.Messages.ConvertPointsToCouponsSuccess, wrapper, wrapper.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Account.Messages.ConvertPointsToCouponsFailure, wrapper, wrapper.onFailure);

});